import { Maybe, PageSlicesStud_Svell_Embed, _Linkable } from 'prismic-types';
import { linkResolver } from 'prismic/linkResolver';
import SliceContainer from 'containers/slices/SliceContainer';
import IframeResizer from 'iframe-resizer-react';
import { useEffect, useRef } from 'react';

/**
 * Props for `StudSvellEmbed`.
 */
export type StudSvellEmbedProps = {
  source?: Maybe<_Linkable>;
};

/**
 * Component for "StudSvellEmbed" Slices.
 */
export const StudSvellEmbed = ({
  source,
}: StudSvellEmbedProps): JSX.Element => {
  const url = linkResolver(source);
  const iframeRef = useRef<HTMLDivElement>(null);

  return (
    <SliceContainer>
      <div ref={iframeRef}>
        <IframeResizer
          style={{ width: '100%', minHeight: '800px' }}
          src={url}
          checkOrigin={false}
          inPageLinks={true}
          heightCalculationMethod="taggedElement"
        />
      </div>
    </SliceContainer>
  );
};

export function prismicSliceToStudSvellEmbed(s: PageSlicesStud_Svell_Embed) {
  const source = s.variation?.primary?.source;

  if (!source) {
    return null;
  }

  return <StudSvellEmbed source={source} />;
}
